// Tarjetas de Identidad de Menores (TIM) de Costa Rica: el payload PDF417, a diferencia de la
// cédula de adulto, NO viene cifrado con XOR — es texto plano tipo CSV seguido de datos binarios
// (foto/firma). Formato observado:
//
//   "identification",expDateDDMMYYYY,birthDateDDMMYYYY,"nombre completo padre","nombre completo madre",
//   apellidoPaterno,apellidoMaterno,"nombre1",nombre2,...(resto no usado + binario)
//
// Los primeros bytes de la cédula de adulto (ver PDF47CRReader) son el XOR de los dígitos
// iniciales de la cédula, no una magia fija (p. ej. "11…" → 0x16 0x01, "40…" → 0x13 0x00).
// Este formato de menor siempre inicia con 0x22 ('"'), lo que permite decidir qué parser usar.

export const PDF47_MINOR_CSV_REGEX = /^"([^"]*)",\d+,\d+,"[^"]*","[^"]*",([^,]*),([^,]*),"([^"]*)",([^,]*),/;

export function isMinorCRDocument(dataFromId) {
  return dataFromId?.[0] === 0x22; // '"'
}

export default function PDF47CRMinorReader(dataFromId) {
  const rawText = dataFromId.map(byte => String.fromCharCode(byte)).join('');
  const match = PDF47_MINOR_CSV_REGEX.exec(rawText);

  if (!match) {
    return { identification: '', first_name: '', last_name: '', last_name_two: '' };
  }

  const [, rawIdentification, last_name, last_name_two, firstGivenName, secondGivenName] = match;
  const identification = rawIdentification.trim().replace(/^0+(?=\d)/, '');
  const first_name = [firstGivenName, secondGivenName]
    .map(name => name.trim())
    .filter(Boolean)
    .join(' ');

  return {
    identification,
    first_name,
    last_name: last_name.trim(),
    last_name_two: last_name_two.trim(),
  };
}
